module.exports = __webpack_public_path__ + "static/media/fail.8c0af66a.png";